import {cloneDeep, get, isString} from "lodash-es";
import {BookingBaseType, BookingType} from "app/app.types";
import ObjectCopyService from "external-services/object-copy-service/index";
import {fromPromise} from "rxjs/internal-compatibility";
import {first} from "rxjs/operators";
import LocationService from "external-services/location-service/index";
import UtilsService from "app/services/utils/utils.service";
import NotesService from "external-services/notes-service/index";
import AdminService from "external-services/diary-admin-service/admin.service";
import PhoneNumberService from "app/services/phoneNumber/phoneNumber.service";
import {BookingStatusNames, BookingStatusTypes} from 'app/bookingStatusTypes';
import TableJoinService, {JOIN_PREFIX} from "app/services/tableJoin/tableJoin.service";
import TelemetryService from "app/services/telemetry/telemetry.service";
import GeneralSettingsService from "external-services/general-settings-service/generalSettings.service";
import { StatusServiceInstance } from "external-services/status-service";
import {isEmpty} from "lodash-es";
import ReportingService from "app/services/reporting/reporting.service";
import BookingLookupService from "external-services/booking-lookup-service/index";
import BookingUpdateService from "external-services/booking-update-service/index";
import BookingValidationService from "shared-services/booking-validation-service/index";
import CustomerNormaliseService from "external-services/customer-normalise-service/index";

const NS = 'RunSheet';
const COLUMN_BOOKING_TYPE = "bookingType";
const UNDEFINED = "undefined";

// requiring html templates so that hot reloading works
import template from './runSheet.html';
import SectionLookupService from "external-services/section-lookup-service/sectionLookup.service";
import LayoutsService from 'external-services/layouts-service/layouts.service';
import PouchActions, {PouchDocType} from "app/actions/pouch.actions";
import PouchSyncService, {quickEditProps} from "external-services/pouch-sync-service/index";
import DateUtilsService from 'external-services/date-utils-service';
import CustomerLookupService from 'external-services/customer-lookup-service';
import {VIEW_CHANGED} from "app/actions/view.actions";
import TablesLookupService from "external-services/tables-lookup-service/tablesLookup.service";
import store from "appRoot/Store";
import {scheduleActions} from 'app/reducers/schedule/slice';
import {floorplanBookingsActions} from "floorplan-v2/app/reducers/bookings/slice";

export default function RunSheet() {
    return {
        bindToController: true,
        controllerAs: 'vm',
        restrict: 'E',
       template,
        scope: {
            date: '<',
            bookings: '<',
            services: '<',
            schedule: '<',
            section: '<',
            selectedSectionIds: '<',
            defaultSectionLayouts: '<',
        },
        controller
    }
}


// just exported for unit tests
export function controller(
    $log, $scope, $rootScope, $window, $filter, $localStorage, $mdDialog,
    appConstants, unregister, $q
) {
    "ngInject";


    var vm = this;
    let customersServiceSubs;
    const timezoneId = AdminService.getVenueTimezoneId();
    vm.quickStatusBooking = null;
    // lifecycle hook
    vm.$onInit = function() {

        // -- properities
        vm.paymentTypes = appConstants.Payment.PaymentTypes;
        vm.notes = '';
        vm.editNotes = false;
        vm.totalCovers = 0;
        vm.totalBookings = 0;
        vm.generatedDate = DateUtilsService.getVenueTime(timezoneId);
        vm.venue = AdminService.getVenue();
        vm.showEmptyTables = $localStorage.showEmptyTables;
        vm.bookingList = [];
        vm.filteredBookings = [];
        vm.emptyTables = [];
        vm.hasPayments = false;
        vm.hasOptions = false;

        vm.showEditBookingNotes = false;
        vm.editBookingNotesData = null;

        // init booking type filter
        vm.isBookingTypeEnabled = $localStorage.runSheetCols &&
            $localStorage.runSheetCols.indexOf(COLUMN_BOOKING_TYPE) !== -1 ?
            true :
            false;

        if (vm.isBookingTypeEnabled) {
            vm.bookingTypePageLoad = true;
            if ($localStorage.allBookings == null || $localStorage.allBookings == UNDEFINED) {
                $localStorage.allBookings = vm.allBookings = true;
            }
            vm.allBookings = $localStorage.allBookings;
            // waitList
            if ($localStorage.waitList == null || $localStorage.waitList == UNDEFINED) {
                $localStorage.waitList = vm.waitList = true;
            }
            vm.waitList = $localStorage.waitList;
            // standbyList
            if ($localStorage.standbyList == null || $localStorage.standbyList == UNDEFINED) {
                $localStorage.standbyList = vm.standbyList = true;
            }
            vm.standbyList = $localStorage.standbyList;
        } // isBookingTypeEnabled
        // overrides setting of standby list filtering
        if (!vm.venue.standByList) {
            vm.standbyList = vm.venue.standByList;
        }

        vm.BookingType = BookingType;
        // -- sorting
        vm.sortBy = 'time';
        vm.sortReversed = false;
        vm.sortOptions = [{
                value: 'tables',
                label: 'Table(s)'
            }, {
                value: 'bookingRef',
                label: 'Reference'
            }, {
                value: 'method',
                label: 'Method'
            }, {
                value: 'people',
                label: 'People'
            }, {
                value: 'time',
                label: 'Booking Start Time'
            }, {
                value: 'endTime',
                label: 'Booking End Time'
            }, {
                value: 'bookedAt',
                label: 'Booked At'
            }, {
                value: 'service.name',
                label: 'Service'
            }, {
                value: 'firstName',
                label: 'First name'
            }, {
                value: 'lastName',
                label: 'Last name'
            }, {
                value: 'company',
                label: 'Company'
            }, {
                value: 'status.name',
                label: 'Status'
            }, {
                value: 'tags',
                label: 'Tags'
            }, {
                value: 'paymentSummary.paymentType',
                label: 'Payment'
            },
            {
                value: 'selectedOptions',
                label: 'Booking Options'
            },
            {
                value: 'bookingLinks',
                label: 'Links'
            },
            {
                value: 'hasVisitedMultipleVenues',
                label: 'Venue History'
            }, {
                value: 'staffName',
                label: 'Staff Name'
            }, {
                value: 'amountSpent',
                label: 'Amount Spent'
            }, {
            value: 'visits',
            label: 'Visits'
          }, {
            value: 'avgSpendAmount',
            label: 'AVG Spend'
          }
        ];

        // Only show if in TA
        if (AdminService.getVenue().isTakeAwayMode === true) {

            var deliveryAddress = { value: 'deliveryAddress', label: 'Delivery Address' };
            vm.sortOptions.push(deliveryAddress);

        }

        if (AdminService.getVenue().isCovidGuestMode === true) {

            var covidGuestList = { value: 'covidGuestList', label: 'COVID Guest List' };
            vm.sortOptions.push(covidGuestList);

        }
        // -- columns
        let runsSheetArray = ['method', 'people', 'bookingStartTime', 'service', 'customer', 'tables', 'contact', 'links', 'company', 'status', 'tags', 'notes'];
        vm.colOptions = [

            {
                value: 'bookingType',
                label: 'Booking Type',
            },
            {
                value: 'bookingRef',
                label: 'Reference'
            }, {
                value: 'method',
                label: 'Method'
            }, {
                value: 'people',
                label: 'People'
            }, {
                value: 'bookingStartTime',
                label: 'Booking Start Time'
            },
            {
                value: 'bookingEndTime',
                label: 'Booking End Time'
            }, {
                value: 'bookedAt',
                label: 'Booked At'
            }, {
                value: 'service',
                label: 'Service'
            }, {
                value: 'customer',
                label: 'Customer'
            }, {
                value: 'tables',
                label: 'Table'
            }, {
                value: 'contact',
                label: 'Contact'
            }, {
                value: 'bookingLinks',
                label: 'links'
            }, {
                value: 'status',
                label: 'Status'
            }, {
                value: 'tags',
                label: 'Tags'
            }, {
                value: 'payment',
                label: 'Payment'
            }, {
                value: 'bookingOptions',
                label: 'Booking Options'
            }, {
                value: 'venueHistory',
                label: 'Venue History'
            }, {
                value: 'notes',
                label: 'Notes'
            }, {
                value: 'staffName',
                label: 'Staff Name'
            }, {
                value: 'amountSpent',
                label: 'Amount Spent'
            }, {
                value: 'visits',
                label: 'Visits'
            }, {
                value: 'avgSpendAmount',
                label: 'AVG Spend'
            }, {
                value: 'membershipNumber',
                label: 'Membership Number'
            }
        ];
      if(vm.venue.enableBookedByOnDiary) {
        runsSheetArray.push('bookedBy');
        vm.colOptions.push({ value: 'bookedBy', label: 'Booked By' });
      }
      vm.cols = ($localStorage.runSheetCols) ?
        $localStorage.runSheetCols.split(',') : runsSheetArray;

        // Only show if in TA
        if (AdminService.getVenue().isTakeAwayMode === true) {
            var deliveryAddressCol = { value: 'deliveryAddress', label: 'Delivery Address' };
            vm.colOptions.push(deliveryAddressCol);

        }

        if (AdminService.getVenue().isCovidGuestMode === true) {
            var covidGuestListCol = { value: 'covidGuestList', label: 'COVID Guest List' };
            vm.colOptions.push(covidGuestListCol);
        }
        // -- methods
        vm.printReport = printReport;
        vm.exportToCSV = exportToCSV;
        vm.exportExcelReport = exportExcelReport;
        vm.saveNotes = saveNotes;
        vm.allowEdit = allowEdit;
        vm.changeSortDirection = changeSortDirection;
        vm.changeSortBy = changeSortBy;
        vm.showCol = showCol;
        vm.formatNumber = (...args) => PhoneNumberService.formatNumber(...args);
        vm.getServiceNames = getServiceNames;
        vm.editBookingNotes = editBookingNotes;
        vm.broadcastEditBookingNotes = broadcastEditBookingNotes;
        vm.openStatusSelector = openStatusSelector;
        // -- listeners
        var listeners = [];
        listeners.push($scope.$watch('vm.cols', colsChange));
        listeners.push($scope.$watch('vm.searchStr', filterBooking));
        listeners.push($scope.$watch('vm.bookings', buildBookingsList));
        listeners.push($scope.$watch('vm.date', getNotes));
        listeners.push($scope.$watch('vm.showEmptyTables', function(value) {
            $localStorage.showEmptyTables = value;
        }));
        listeners.push($rootScope.$on(VIEW_CHANGED, (evt, data) => {
          if (data.payload === appConstants.ViewTypes.runsheet) {
            getTablesLookUp();
          }
        }));

        listeners.push($scope.$watch('vm.allBookings', function(value) {
            $localStorage.allBookings = value;
        }));

        listeners.push($scope.$watch('vm.waitList', function(value) {
            $localStorage.waitList = value;
        }));
        listeners.push($scope.$watch('vm.standbyList', function(value) {
            $localStorage.standbyList = value;
        }));

        listeners.push(
          PouchActions.handlePouchSyncedDoctype(PouchDocType.booking, (evt, ids) => bookingChange(ids))
        );

        // $rootScope.$on('pouch-synced-doctype-note', getNotes);
        PouchActions.handlePouchSyncedDoctype(PouchDocType.note, () => getNotes());
        listeners.push($scope.$on('$destroy', () => unregister(listeners)));
        listeners.push($scope.$watch("vm.isBookingTypeEnabled", filterBooking));
        listeners.push($scope.$watch("vm.allBookings", filterBooking));
        listeners.push($scope.$watch("vm.waitList", filterBooking));
        // if venue standByList is enabled
        if (vm.venue.standByList) {
            listeners.push($scope.$watch("vm.standbyList", filterBooking));
        }

        getSectionsLookUp();
        getTablesLookUp();
    }; // end $onInit

    vm.$onDestroy = () => {
        if (customersServiceSubs) {
            customersServiceSubs.unsubscribe();
        }
    };

  function getTablesLookUp() {
    vm.tablesLookup = TablesLookupService.getTablesLookup();
  }

  async function bookingChange(updatedBookingIds) {
    if (updatedBookingIds.length === 1) {
      // if only 1 booking has been updated, don't re-render everything if it is just a quick edit
      const updatedBookingId = updatedBookingIds[0];
      let originalBooking = vm.filteredBookings.find(b => b._id === updatedBookingId);

      if(vm.quickStatusBooking && originalBooking && originalBooking._id === vm.quickStatusBooking._id) {
        originalBooking = cloneDeep(originalBooking);
        originalBooking.status = vm.quickStatusBooking.status;
        vm.quickStatusBooking = null;
      }

      let newBooking;
      try {
        newBooking = await BookingLookupService.getById(updatedBookingId, vm.date);
      } catch (err) {
        console.warn(NS, `error retrieving booking by id "${updatedBookingId}".`);
        return;
      }

      const containsOnlyQuickChanges = PouchSyncService.containsOnlyQuickChanges(originalBooking, newBooking, false, true);

      /**
       * The reason we only update these 2 properties (and deliberately mutate the object), instead of replacing the
       * whole object, is because the dragged booking has a reference to the same object and won't update with it unless
       * it is mutated. This is a bit ugly, but because the dragged booking is not rendered until it is interacted with
       * we can't update it with `PouchActions.handlePouchSyncedDoctype` in real time.
       */
      if (containsOnlyQuickChanges) {
        // need to update this list too for wait list bookings in BCL
        let originalBooking2 = vm.bookings.find(b => b._id === updatedBookingId);

        quickEditProps.forEach(propName => {
          originalBooking[propName]  = newBooking[propName];
          originalBooking2[propName]  = newBooking[propName];
        });

        originalBooking._rev = newBooking._rev; // needs rev to avoid conflicts
        originalBooking2._rev = newBooking._rev; // needs rev to avoid conflicts

        buildBookingsList();
      }
    }
  }

    function colsChange() {
        // the full DB is needed for visits, because it needs to collect historical data
        const isFullBookingList = vm.cols.find(col => col === 'visits');
        if (isFullBookingList) {
          buildBookingsList();
        }
        $localStorage.runSheetCols = vm.cols.join(',');
        const isBookingType = vm.cols.some((x) => x === COLUMN_BOOKING_TYPE);
        if (isBookingType) {
            // do noting on page load
            if (!vm.bookingTypePageLoad) {
                // set values
                vm.isBookingTypeEnabled = true;
                vm.standbyList = vm.waitList = vm.allBookings = true;
                // if disable by settings then put it off
                if (!vm.venue.standByList) {
                    vm.standbyList = false;
                }
            }
        } else {
            vm.standbyList = vm.waitList = vm.allBookings = vm.isBookingTypeEnabled = false;
            vm.bookingTypePageLoad = false;
        }
        return;
    }

    function printReport() {

        // Testing for IPad and Ipad Chrome
        //const isIpad = (navigator.userAgent.search("iPad") >= 0);
        const isChromeIpad = LocationService.isChromeIPAD();
        const isSafari = (LocationService.isSafari());

        if (isChromeIpad || !isSafari) {
            window.print();
        }
        else {
            try {
                document.execCommand('print', false, null);
            } catch {
                window.print();
            }
        }
    }

    function changeSortDirection() {
        vm.sortReversed = !vm.sortReversed;
        changeOrder();
    }

    function changeSortBy() {
        vm.sortReversed = false;
        changeOrder();
    }

    function filterBooking() {
        if (vm.bookingList && vm.bookingList.length) {
            var filteredBookings = vm.bookingList;
            // is bookingtype filter enabled
            if (vm.isBookingTypeEnabled) {
                let filteredBookings_types = [];
                if (vm.allBookings || vm.waitList || vm.standbyList) {
                    let listAllBookings = [];
                    let listAllWaits = [];
                    let listAllStandbys = [];
                    if (vm.allBookings) {
                        listAllBookings = vm.bookingList.filter((x) => x.bookingType === BookingType.Booking);
                    }
                    if (vm.waitList) {
                        listAllWaits = vm.bookingList.filter((x) => x.bookingType === BookingType.WaitList);
                    }
                    // if vm.venue.standByList true then filter would work
                    if (vm.venue.standByList) {
                        if (vm.standbyList) // only when venue standlist enabled
                        {
                            listAllStandbys = vm.bookingList.filter((x) => x.bookingType === BookingType.StandbyList);
                        }
                    } else {
                        listAllStandbys = vm.bookingList.filter((x) => x.bookingType === BookingType.StandbyList);
                    }
                    filteredBookings_types = listAllBookings.concat(listAllWaits).concat(listAllStandbys);
                    filteredBookings = filteredBookings_types;
                }
                filteredBookings = filteredBookings_types;
            } // if booking type filtering enabled
            vm.filteredBookings = filteredBookings;
            // search
            if (vm.searchStr) {
                filteredBookings = [];
                vm.filteredBookings.forEach((booking) => {
                    if (bookingMatch(vm.searchStr, booking)) {
                        filteredBookings.push(booking);
                    }
                });
            }
            vm.filteredBookings = filteredBookings;
            changeOrder();
        }
    } // function

    function bookingMatch(query, booking) {
        var lowercaseQuery = query.toLowerCase();
        var bookingFullName = (booking.firstName + ' ' + booking.lastName).toLowerCase();
        if (bookingFullName && bookingFullName.toLowerCase().indexOf(lowercaseQuery) === 0) {
            return true;
        }
        if (booking.firstName && booking.firstName.toLowerCase().indexOf(lowercaseQuery) === 0) {
            return true;
        }
        if (booking.lastName && booking.lastName.toLowerCase().indexOf(lowercaseQuery) === 0) {
            return true;
        }
        if (booking.company && booking.company.toLowerCase().indexOf(lowercaseQuery) === 0) {
            return true;
        }
        return false;
    }

    function changeOrder() {
        // making sure JSON objects are properly converted to a string for sorting, and if arrays are empty they should be treated same as missing property
        var filterFunction = function(item) {
            // Handle special case for endTime sorting
            if (vm.sortBy === 'endTime') {
                return item.bookingEnd;
            }
            
            if (item[vm.sortBy] && Array.isArray(item[vm.sortBy]) && item[vm.sortBy].length === 0) {
                return undefined;
            }
            else {
                var value = get(item, vm.sortBy);
                var result = !isString(value) ? JSON.stringify(value) : value;

                return result;
            }
        };

        var valueParts = [filterFunction, 'lastName', 'time'];
        vm.filteredBookings = $filter('orderBy')(vm.filteredBookings, valueParts, vm.sortReversed);

        // if table.name has a NaN string in it then tries to retrieve into tableXNum variable only the numeric part
        // if tableXNum is still NaN then returns 0 for not affecting the sorting method
        if (vm.sortBy === 'tables') {

            function compare(a, b) {

                if ((Array.isArray(a.tables) && a.tables.length && Array.isArray(b.tables) && b.tables.length)) {

                    const tableA_name = a.tables[0].name;
                    const tableANum = (isNaN(tableA_name) ? tableA_name.substring(0, tableA_name.indexOf(" ")) : tableA_name)

                    const tableB_name = b.tables[0].name;
                    const tableBNum = (isNaN(tableB_name) ? tableB_name.substring(0, tableB_name.indexOf(" ")) : tableB_name)

                    return (isNaN(tableANum) || isNaN(tableBNum) ? 0 : tableANum - tableBNum);
                }

                return 1;
            }

            function compareReversed(a, b) {

                if ((Array.isArray(a.tables) && a.tables.length && Array.isArray(b.tables) && b.tables.length)) {

                    const tableA_name = a.tables[0].name;
                    const tableANum = (isNaN(tableA_name) ? tableA_name.substring(0, tableA_name.indexOf(" ")) : tableA_name)

                    const tableB_name = b.tables[0].name;
                    const tableBNum = (isNaN(tableB_name) ? tableB_name.substring(0, tableB_name.indexOf(" ")) : tableB_name)

                    return (isNaN(tableBNum) || isNaN(tableANum) ? 0 : tableBNum - tableANum);
                }

                return -1;
            }

            if (vm.sortReversed) {
                vm.filteredBookings.sort(compareReversed);
            } else {
                vm.filteredBookings.sort(compare);
            }

        }

        if (vm.sortBy === 'people') {

            function comparePeople(a, b) {
                return a.people - b.people;
            }

            function comparePeopleReversed(a, b) {
                return b.people - a.people;
            }

            if (vm.sortReversed) {
                vm.filteredBookings.sort(comparePeopleReversed);
            } else {
                vm.filteredBookings.sort(comparePeople);
            }

        }

        if (vm.sortBy === 'endTime') {

            function compareEndTime(a, b) {
                return new Date(a.bookingEnd) - new Date(b.bookingEnd);
            }

            function compareEndTimeReversed(a, b) {
                return new Date(b.bookingEnd) - new Date(a.bookingEnd);
            }

            if (vm.sortReversed) {
                vm.filteredBookings.sort(compareEndTimeReversed);
            } else {
                vm.filteredBookings.sort(compareEndTime);
            }

        }

    }

    function getSectionsLookUp() {
      SectionLookupService.getSectionsLookUp().then(function(sections) {
            vm.sectionsLookup = sections;
            buildBookingsList();
        }).catch(function(err) {
            $log.error('error getSectionsLookUp', err);
        });
    }

    function allowEdit() {
        vm.editNotes = true;
    }

    function getNotes() {
        NotesService.getNote(vm.date).then(function(noteDoc) {
            vm.noteDoc = noteDoc;
            vm.notes = noteDoc.note;
            vm.editNotes = false;
        }).catch(function() {
            vm.notes = '';
            vm.editNotes = true;
            vm.noteDoc = {};
        });
    }

    function getEmptyTables() {
        if (vm.bookings) {
            var sectionLayouts = (vm.services && vm.services.length) ?
                vm.services.reduce((acc, s) => (acc.concat(s.sectionLayouts)), []) :
                vm.defaultSectionLayouts;

            if (sectionLayouts) {
                // get the layouts by id
                var layoutsIds = [];
                for (var i = 0; i < sectionLayouts.length; i++) {
                    var sectionLayout = sectionLayouts[i];
                    // limit the section if one is selected
                    if ((!vm.selectedSectionIds || vm.selectedSectionIds.indexOf(sectionLayout.sectionId) !== -1)) {
                        layoutsIds.push(sectionLayout.layoutId);
                    }
                }

                // taken table ids
                var takenTableIds = {};
                for (var j = 0; j < vm.bookings.length; j++) {
                    var booking = vm.bookings[j];
                    if (booking.status._id !== 'status_cancelled') {
                        var tables = booking.tables;
                        if (tables) {
                            for (var t = 0; t < tables.length; t++) {
                                takenTableIds[tables[t]._id] = true;
                            }
                        }
                    }
                }

                LayoutsService.getByLayouts(layoutsIds, vm.date).then(function(results) {
                    var tablesList = results.tablesArray;
                    tablesList = tablesList.filter(function(t) {
                        return !takenTableIds[t._id];
                    });
                    vm.emptyTables = $filter('alphaSortFilter')(tablesList, 'name');
                }).catch(function(err) {
                    $log.warn('err', err);
                });
            }
        }
    }

    function saveNotes() {
        if (!vm.noteDoc) {
            vm.noteDoc = {};
        }
        vm.noteDoc.note = vm.notes;
        NotesService.saveNote(vm.date, vm.noteDoc).then(function() {
            store.dispatch(scheduleActions.setVenueNotes(vm.notes));
        }).catch(function(err) {
            $log.error('error saving notes', err);
        });
        vm.editNotes = false;
    }

    function showCol(col) {
        if (vm.cols.indexOf(col) !== -1) {
            return true;
        }
        return false;
    }

    function buildBookingsList() {
        if (!vm.sectionsLookup || vm.quickStatusBooking) {
          return;
        }

        vm.generatedDate = DateUtilsService.getVenueTime(timezoneId);
        vm.totalCovers = 0;
        vm.totalBookings = 0;
        vm.hasPayments = false;
        vm.hasOptions = false;

        if (!vm.bookings) {
            vm.bookingList = [];
            vm.filteredBookings = [];
            return;
        }

        var totalCovers = 0;
        var totalBookings = 0;
        var customersIds = [];
        var bookings = ObjectCopyService.angularSafeCopy(vm.bookings) || [];
        var bookingList = [];

        if (vm.schedule) {

            var privateFunctions = vm.schedule.services.filter(function(service) {
                return isPrivateFunEvent(service);
            });

            for (var e in privateFunctions) {
                var privateFunction = privateFunctions[e];

                totalCovers += Number(privateFunction.people);

                var status = '';
                if (privateFunction.paymentDetails.paymentType === appConstants.Payment.PaymentTypes.FunctionPayment) {
                    status = 'Payment Pending';
                    if (privateFunction.paymentSummary) {
                        status = 'Paid';
                    }
                }

                if (privateFunction.paymentDetails && privateFunction.paymentDetails.amount !== 0) {
                    vm.hasPayments = true;
                }

                var sectionsList = [];

                for (var s in privateFunction.sectionLayouts) {
                    var sectionLayout = privateFunction.sectionLayouts[s];
                    // added a check for vm.sectionsLookup as well because it is possible for this to have not loaded yet
                    if (sectionLayout.layoutId && vm.sectionsLookup) {
                        sectionsList.push(vm.sectionsLookup[sectionLayout.sectionId].name);
                    }
                }

                var eventDisplay = {
                    firstName: privateFunction.firstName,
                    lastName: privateFunction.lastName,
                    phone: privateFunction.phone,
                    email: privateFunction.email,
                    people: privateFunction.people,
                    time: privateFunction.startTime,
                    endTime: privateFunction.startTime,
                    service: {
                        name: privateFunction.name
                    },
                    sections: sectionsList.join(', '),
                    customerId: privateFunction.customerId,
                    status: {
                        name: status
                    },
                    paymentDetails: privateFunction.paymentDetails,
                    paymentSummary: privateFunction.paymentSummary,
                    notes: privateFunction.description,
                    type: 'event',
                    bookingType: BookingType.Booking
                };

                customersIds.push(privateFunction.customerId);
                bookings.push(eventDisplay); // private bookings are treated as bookings, as they effectively block that section from being used
            }

            getEmptyTables();
        }

        const activeBookings = bookings.filter(b => b.status.statusType !== BookingStatusTypes.Cancelled);
        activeBookings.forEach(booking => {
            if (booking.customerId) {
                customersIds.push(booking.customerId);
            }
        });

        // cancel existing subscription, just in case still in progress
        if (customersServiceSubs) {
            customersServiceSubs.unsubscribe();
        }

        const copyCustomerIds = cloneDeep(customersIds);
        // using observable instead of promise, so it can be cancelled properly
        customersServiceSubs = fromPromise(
          CustomerLookupService.getByIds(customersIds)
        ).pipe(
            first()
        ).subscribe(async (customers) => {
          // the full DB is needed for visits, because it needs to collect historical data
          const isFullBookingList = vm.cols.find(col => col === 'visits');
          // we need customerBookingList to get the visits information
          const customerBookingList = await BookingLookupService.getBookingsByCustomerIds(copyCustomerIds, isFullBookingList);
          vm.customerBookings = customerBookingList.filter(booking => BookingValidationService.isValidPastBooking(booking));

          // we need to call getCustomersSpendInfo to get the avgSpend for all customers
          if (!isEmpty(copyCustomerIds)) {
            vm.customersSpendInfo = await ReportingService.getCustomersSpendInfo(vm.venue.id, copyCustomerIds);
          }

          // evalAsync was needed to force angular to re-render
          $scope.$evalAsync(() => {
            updateBookingDetailsWithCustomerInfo(customers, activeBookings, bookingList, totalCovers, totalBookings, vm.customerBookings, vm.customersSpendInfo);
          // adding filteredStatusList so each booking has it's own custom list of statuses in list
                bookingList.forEach((booking) => {
                  booking.filteredStatusList = StatusServiceInstance.getFilteredStatusList(booking.status.name, booking);
                });
            });
        }, err => {
            $log.error('error get customers by ids', err);
        });
    }
/**

     * Waits until customer info has been loaded before updating booking info
     */
    function updateBookingDetailsWithCustomerInfo(customers, activeBookings, bookingList, totalCovers, totalBookings, customerBookings, customersSpendInfo) {
        for (let j in activeBookings) {
            let booking = activeBookings[j];

            // Calculate booking end time
            booking.bookingEnd = DateUtilsService.getBookingEnd({
                time: booking.time,
                duration: booking.duration
            });

            booking.visits = booking.customerId ? customerBookings.filter(customerBooking => booking.customerId === customerBooking.customerId).length : 0;
            booking.avgSpendAmount = booking.customerId ? ReportingService.getAvgSpendAmountForBooking(booking.customerId, customersSpendInfo) : 0;

            if (booking.paymentSummary && booking.paymentSummary.amount !== 0) {
                vm.hasPayments = true;
            }

            if (booking.selectedOptions && booking.selectedOptions.length > 0) {
                vm.hasOptions = true;
            }

            booking.linkNotes = UtilsService.addLinksToText(booking.notes);

            if (customers) {
                var bookingCustomer = customers.find(function(customer) {
                    return (customer._id === booking.customerId) || (customer.venueIds.length && customer.venueIds.find(function(venueId) {
                        return venueId === booking.customerId;
                    }));
                });

                CustomerNormaliseService.updateBookingCustomerInfo(booking, bookingCustomer);

                // if not an event, update booking tags
                if (booking.type !== 'event') {
                    BookingUpdateService.updateBookingPermanentTags(booking, bookingCustomer);
                }
                booking.customerLinkNotes = bookingCustomer ? UtilsService.addLinksToText(bookingCustomer.notes) : false;
                booking.membershipNumber = bookingCustomer ? bookingCustomer.membershipNumber : '';
            }

            // select the service based on the time of the day
            if (booking.type !== 'event') {
                attachServiceBasedOnTime(booking);
            }

            // add empty payment summary purely for sorting reasons
            if (!booking.paymentSummary) {
                booking.paymentSummary = {
                    paymentType: ''
                };
            }

            if (booking.type !== BookingBaseType.event && booking.bookingType == BookingType.Booking) {
                totalCovers += booking.people;
                totalBookings++;
            }

            bookingList.push(booking);
        }

        // format for empty booking types if any for old database
        bookingList.forEach((e) => {
            if (!e.bookingType) {
                if (!e.tables || e.tables.length === 0) {
                    e.bookingType = BookingType.WaitList;
                } else {
                    e.bookingType = BookingType.Booking;
                }
            }
        });
        vm.bookingList = bookingList;
        vm.filteredBookings = bookingList;
        // if booking type enabled
        if (vm.isBookingTypeEnabled) {
            // get filter data
            filterBooking();
        }
        changeOrder();
        vm.totalCovers = totalCovers;
        vm.totalBookings = totalBookings;
    }

    function attachServiceBasedOnTime(booking) {
        // select the service based on the time of the day
        for (var s in vm.schedule.services) {
            var service = vm.schedule.services[s];
            var inService = false;
            if (booking.serviceId) {
                // check the service via the serviceId
                if (booking.serviceId === service._id) {
                    inService = true;
                }
            } else {
                // check the service via the time of the booking
                var serviceStartDate = service.startTime;
                var serviceEndDate = service.endTime;
                if (DateUtilsService.isInBetweenDates(booking.time, serviceStartDate, serviceEndDate)) {
                    inService = true;
                }
            }
            // test if they are in the current layout
            if (inService) {
                booking.service = service;
                break;
            }
        }
    }

    function exportToCSV() {
        $mdDialog.show({
            controller: 'ExportRunsheetDialogCtrl',
            controllerAs: 'vm',
            templateUrl: 'app/bookings/runSheet/exportRunsheetDialog.html',
            parent: angular.element(document.body),
            clickOutsideToClose: true,
            locals: {
                bookings: vm.bookings,
                date: vm.date,
                generatedDate: vm.generatedDate,
                services: vm.services,
                selectedSectionIds: vm.selectedSectionIds
            }
        });
    }

    function exportExcelReport() {
        $mdDialog.show({
            controller: 'ExportExcelReportDialogCtrl',
            controllerAs: 'vm',
            templateUrl: 'app/bookings/runSheet/exportExcelReportDialog.html',
            parent: angular.element(document.body),
            clickOutsideToClose: true,
            locals: {
                bookings: vm.bookings,
                date: vm.date,
                generatedDate: vm.generatedDate,
                services: vm.services,
                selectedSectionIds: vm.selectedSectionIds
            }
        });
    }

    function getServiceNames() {
        return `<b>Service${vm.services.length > 1 ? 's' : ''}:</b> ${vm.services.map(s => s.name).join(', ')}`;
    }

    // Edit notes start //
    function editBookingNotes(evt = null, booking = null) {
      vm.showEditBookingNotes = !vm.showEditBookingNotes;
      if(booking) vm.editBookingNotesData = booking;
    }

    function broadcastEditBookingNotes(editBooking) {
      $rootScope.$broadcast('booking-edited', editBooking);
      buildBookingsList();
    }

    function openStatusSelector(booking) {
      store.dispatch(
        floorplanBookingsActions.setSelectedBookingForStatusModal({
          statusId: booking.status._id,
          bookingId: booking._id,
        })
      );
    }

    // Edit notes end //
    /**
     * PRIVATE METHODS BELOW HERE
     */

    function isPrivateFunEvent(service) {
        return service && service.type === 'event' && service.eventType === 'PrivateFunction';
    }
}
